module.exports = __webpack_public_path__ + "images/outside.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/outside.png
// module id = 46
// module chunks = 0